import { render, staticRenderFns } from "./CustomerWsuView.vue?vue&type=template&id=77c3d5f0&scoped=true&"
import script from "./CustomerWsuView.vue?vue&type=script&lang=js&"
export * from "./CustomerWsuView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c3d5f0",
  null
  
)

export default component.exports